import React, { useContext, useState } from 'react'
import ChallengeBar from './chalengeBar/chalengeBar.js'
import ChatBar from './chatBar/ChatBar.js'
import MiniLeftBar from './LeftBar/miniLeftBar.js'
import ProfileBar from './LeftBar/profileBar.js'
import MeassageBox from './messageBox/messagebox.js'
import TopBar from './topBar/topBar.js'
import  styles  from "./main.module.css";
import UserDataContextProvider from '../../context/userData.js'
import Stats from './stats/stats.js'
import {  BrowserRouter as Router,
     Switch,Route,useRouteMatch, Link, Redirect } from 'react-router-dom'
import Profile from './profile/profile.js'
import { UserContext } from '../../context/userContext.js'
import { NavIconContext } from '../../context/NavIconContext.js'
import Vlinks from './Vlinks/vlinks.js'
import Newfeed from './newfeed/newfeed.js'
import AddPost from './addPost/addPost.js'
import Challenge from './challange/challenge.js'
import EditProfile from './editProfile/editProfile.js'
import Setting from './setting/setting.js'
import Hashtag from './hastag/hashtag.js'
import Addimages from './addPost/addImages.js'
import Notifications from './notification/notifcation.js'
import Activity from './activity/activity.js'
import Explore from './explore/expore.js'
import MySaves from './mysaves/mysaves.js'
import FollowingList from './following/following.js'



export default function Dashbord() {
    const { url, path } = useRouteMatch()
    const{user}=useContext(UserContext);
    const {iconState,addpost,notifcationShow} =useContext(NavIconContext);

if(user){
    return (
       
        <div className={styles.main}> 
  <UserDataContextProvider>
      
    
  <MeassageBox/> 

      
        <TopBar/>
         <MiniLeftBar/>
       
         <TopBar/>
            
            <ChatBar/>
         <ProfileBar/>

         {notifcationShow?<Notifications/>:""}

         <div className={styles.chanllangebar}>
         <ChallengeBar/>
       </div>
      
       
            <div style={{display:'flex',flexDirection:"column"}}>
         
        
         
          <div className={styles.mainSec}> 
          {addpost? <AddPost/>:""} 
          <Route path={`${path}Post_Image`}>
        <Addimages/>
        </Route>
      

        <Route  path={`${path}profile/:username`}>
            <div >
         <Profile/>
         </div>
        </Route>

        <Route path={`${path}c/:id`}>
            <Challenge/>
        </Route>
        <Route path={`${path}hashtag/:id`}>
           <Hashtag/>
        </Route>
        <Route path={`${path}explore`}>
           <Explore/>
        </Route>
        <Route path={`${path}setting`}>
            <Setting/>
        </Route>

         <Route exact path="/">
     
         
        
        {iconState==="stats"?<Stats/>:""}


        <div className={styles.ProfileCard}>

            

        </div>



        {iconState==="vlink"?<Vlinks/>:""}



        {iconState==="newfeed"?<Newfeed/>:""}
        {iconState==="activity"?<Activity/>:""}
        {iconState==="mysaves"?<MySaves/>:""}
        {iconState==="followingList"?<FollowingList/>:""}
       
       
        </Route>
        </div>
     

        

            </div>
            </UserDataContextProvider>
        </div>
       
    )}else{
        return(
        <Redirect to="/account"/>
        )}
}
